import type { CSSProperties } from 'react';

import { Button } from '@heroui/react';
import { useTranslation } from 'react-i18next';

import { BaseErrorCard } from './BaseErrorCard';

interface Props {
  className?: string;
  handleReload?: () => void;
  isLoading?: boolean;
  style?: CSSProperties;
  title?: string;
}

export function RetryErrorCard({
  className = '',
  handleReload = () => {},
  isLoading = false,
  style = {},
  title = undefined,
}: Props) {
  const { t } = useTranslation('ui');

  return (
    <BaseErrorCard
      actionElement={
        <Button
          data-testid="retry-button"
          isLoading={isLoading}
          onPress={handleReload}
        >
          {t('retry')}
        </Button>
      }
      className={className}
      style={style}
      title={title}
    />
  );
}
